import { render, staticRenderFns } from "./ClientsWidget.vue?vue&type=template&id=38de4010"
import script from "./ClientsWidget.vue?vue&type=script&lang=js"
export * from "./ClientsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports